import toCamelCase from "@/utils/toCamelCase";

/**
 * Creates a function that extracts HTML attributes with a specific prefix from an Element
 * and returns them as a camelCased key-value pair object.
 *
 * @param {string} prefix - The prefix to filter HTML attributes (e.g., "data-")
 * @returns {function(element: Element) => Record<string, string>} - A function that takes an Element and returns an object with filtered attributes
 *
 * @example
 * const getDataAttrs = getHTMLAttrs('data-');
 * const element = document.querySelector('#myElement');
 * const attributes = getDataAttrs(element);
 */
export default function getHTMLAttrs(prefix: string) {
	return (element: Element): Record<string, string> => {
		const result = Array.from(element.attributes)
			.filter((attr) => attr.name.startsWith(prefix))
			.reduce(
				(attrs, attr) => {
					attrs[toCamelCase(attr.name.substring(prefix.length))] = attr.value;
					return attrs;
				},
				{} as Record<string, string>,
			);
		return result;
	};
}
